import Button from 'components/_UI/Button'
import ImageUpload from 'components/_UI/ImageUpload'
import Text from 'components/_UI/Text'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { Column } from 'styled/alignment/Column'
import colors from 'theme/colors'

export default function ImageInfo({ onToggleImage, onDeleteFile, errorImage}) {
    const [tryAgain, setTryAgain] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        console.log(errorImage)
        if(errorImage) {
            setError(true)
        }
    }, [errorImage])

    function toggleFile(files) {
        onToggleImage(files[0]);
    }
    
    return (
        <Column marginTop='16px'>
            <Text size='small' type='bold'> Imagem do evento </Text>
            <Text size='small' color={colors.night}>Selecione uma imagem para ser a capa do seu evento.</Text>

            <ImageUpload 
                onToggleFile={toggleFile} 
                onDeleteFile={() => onDeleteFile()}
                tryAgain={tryAgain} 
                
                refreshTryAgain={() => {
                    setTryAgain(!tryAgain)
                    setError(error)
                }} 
            />
       
        {
            error && (
                <Column marginTop='20px'>
                    <Text color={colors.danger}>Ocorreu um erro ao cadastrar a imagem</Text>
                    <Button 
                        variant='secondary' 
                        onClick={() =>  {
                            setTryAgain(true)
                            setError(false)
                        }}
                        > 
                        Tentar novamente {JSON.stringify(error)}
                        </Button>
                </Column>
            ) 
                
        }

        
        </Column>
    )
}